

























import { Component, Prop } from "vue-property-decorator";

import { BaseBorderless } from "@share/common/form/form-controls/base/borderless/base-borderless";
import DatePick from 'vue-date-pick/src/vueDatePick.vue';
import CalendarSvg from '../../../../../../assets/svg/calendar.svg';
import { getVueDatePickLocale } from "@common/vueDatePick";
import {DateTime} from "luxon";
import { setPickerSide } from "@share/date-switcher/helpers";

@Component({ components: { CalendarSvg, DatePick } })
export default class DatePickerInput extends BaseBorderless {

    @Prop({ default: "" }) declare value: string | DateTime;

    @Prop({default: 'en'}) lang: string;
    @Prop({default: true}) withIcon: boolean;
    @Prop({default: false}) convertModel: boolean;
    @Prop() pickerSide: "left" | "right" | "";

    datePickLocale: any = {};
    positionFloaterCb = null;

    created() {
        this.datePickLocale = getVueDatePickLocale(this.lang);
    }

    openPicker(cb: () => {}) {
        cb();
        this.setSide()
    }

    setSide() {
        const picker = (this.$refs["picker"] as { positionClass: string } | any | undefined);

        if(!picker) {
            return
        }

        if(this.pickerSide) {
            this.positionFloaterCb = picker.positionFloater;
            picker.positionFloater = () => {return}
            this.setDatePickerSide(picker)
        }
        else if(this.positionFloaterCb) {
            picker.positionFloater = this.positionFloaterCb
        }
    }

    setDatePickerSide(picker?: any) {
        if(!picker) {
            picker = (this.$refs["picker"] as { positionClass: string } | any | undefined);
        }

        if(!picker) {
            return
        }

        setPickerSide(picker, this.pickerSide)
    }

    get model() {
        if (this.convertModel && typeof this.value == 'object') {
            return this.value?.toISO() || '';
        }
        return this.value as string;
    }

    /**
     * @override set model()
     */
    set model(value: string) {
        const emitValue = this.convertModel
            ? (value ? DateTime.fromISO(value) : null)
            : value;

        this.$emit('input', emitValue)
        this.$emit("changed", emitValue);
    }
}

